import styled from '@emotion/styled'
import React from 'react'
import { STEP_LAYOUT_SMALL_WIDTH } from '../shared/shared-step-layout.styled'

interface StepButtonsProps {
  children: React.ReactNode
}

export default function StepButtons({ children }: StepButtonsProps) {
  return <ButtonContainer>{children}</ButtonContainer>
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;

  @media (max-width: ${STEP_LAYOUT_SMALL_WIDTH}) {
    display: flex;
    flex-direction: column-reverse;
  }
`
